import { colors } from '../../colors';
var header = {
  primaryColor: colors.darkNight,
  hoverColor: colors.burntOrange,
  borderColor: colors.overcast,
  bgColor: colors.white,
  barColor: colors.darkNight,
  navContactLinkHoverTextDecoration: "underline",
  navUtilityLinkColor: colors.darkNight,
  navUtilityLinkHoverColor: colors.darkNight,
  navUtilityLinkTextDecoration: "none",
  navUtilityLinkHoverTextDecoration: "underline",
  topNavLineHeight: '18px'
};
export default header;